import { TranslationId } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { ErrorSpecification } from './error-specification';

export interface TranslocoErrorSpecification extends ErrorSpecification {
  type: 'transloco';
  descriptions?: TranslationId[];
  forErrorTypes?: string[];
  title?: Observable<string>;
  buttonName?: Observable<string> | null;
}
